import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { TicketCenterComponent } from './ticket-center/ticket-center.component';
import { TicketCreateComponent } from './ticket-create/ticket-create.component';
import { TicketDetailComponent } from './ticket-detail/ticket-detail.component';

@NgModule({
  declarations: [TicketCenterComponent, TicketCreateComponent, TicketDetailComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DialogModule, TableModule, ButtonModule, DropdownModule, InputTextModule, TooltipModule],
  exports: [TicketCenterComponent],
})
export class TicketModule {}
